import React from 'react'
import resource1Img from '../assets/resource/about8-1.jpg';
import resource2Img from '../assets/resource/about8-2.jpg';

function about() {
  return (
    <section class="about-section-eight" id="about">
    <div class="auto-container">
        <div class="outer-box">
        <div class="icon-flower-19"></div>
        <div class="row">
            <div class="about-block-eight col-lg-6 col-md-6 col-sm-12 wow fadeInLeft">
            <div class="inner-box">
                <div class="image-box">
                <figure class="image overlay-anim"><img src={resource1Img} alt="Image" /></figure>
                </div>
                <div class="content-box">
                <span class="designation">Bride</span>
                <h4 class="name"><a href="#">Malina Kysar</a></h4>
                <div class="text">
                    We are professional wedding planners, <br />
                    based near Oslo, Norway. We have more <br />
                    than 20 years experience
                </div>
                <ul class="social-icon-two">
                <li><a href="#"><i class="icon fab fa-twitter"></i></a></li>
                <li><a href="#"><i class="icon fab fa-facebook-f"></i></a></li>
                <li><a href="#"><i class="icon fab fa-linkedin-in"></i></a></li>
                <li><a href="#"><i class="icon fab fa-instagram"></i></a></li>
                </ul>
                </div>
            </div>
            </div>

            <div class="about-block-eight style-two col-lg-6 col-md-6 col-sm-12 wow fadeInRight">
            <div class="inner-box">
                <div class="image-box">
                <figure class="image overlay-anim"><img src={resource2Img} alt="Image" /></figure>
                </div>
                <div class="content-box">
                <span class="designation">Groom</span>
                <h4 class="name"><a href="#">Alan Hijan</a></h4>
                <div class="text">
                    We are professional wedding planners, <br />
                    based near Oslo, Norway. We have more <br />
                    than 20 years experience
                </div>
                <ul class="social-icon-two">
                <li><a href="#"><i class="icon fab fa-twitter"></i></a></li>
                <li><a href="#"><i class="icon fab fa-facebook-f"></i></a></li>
                <li><a href="#"><i class="icon fab fa-linkedin-in"></i></a></li>
                <li><a href="#"><i class="icon fab fa-instagram"></i></a></li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
</section>
  )
}

export default about